import React from 'react';
import { useSelector } from 'react-redux';
import { TableCell } from 'semantic-ui-react';

import { AppState } from 'services/types';
import {
    WorksheetPageIndex,
    WorksheetEntitySummaryIndex
} from 'services/worksheet/types';
import { makeSelectApplicationType } from './selectors';

export interface Props {
    pageIndex: WorksheetPageIndex;
    entitySummaryIndex: WorksheetEntitySummaryIndex;
}

export default function ApplicationTypeTableCell(
    props: Props
): React.ReactElement {
    const { pageIndex, entitySummaryIndex } = props;
    const applicationType = useSelector((state: AppState) =>
        makeSelectApplicationType()(state, { pageIndex, entitySummaryIndex })
    );

    return <TableCell>{applicationType}</TableCell>;
}
